<template>
  <div class="wrapper">
    <div class="content">
      <div class="filters">
        <span
          v-if="vehicles.length"
          class="results-count"
        >{{ $tc('components.booking.results_number', 0, {resultsCount: vehicles.length}) }}</span>
        <div class="filters-container">
          <div
            v-for="filter in filters"
            :key="filter"
          >
            <input
              v-model="activeFilter"
              :value="filter"
              type="radio"
              name="filter"
              :id="`filter-${filter}`"
            >
            <label
              class="filter-label"
              :for="`filter-${filter}`"
            >
              {{ filter }}
            </label>
          </div>
        </div>
      </div>
      <div class="vehicles">
        <booking-card
          v-for="vehicle in filteredVehicles"
          :key="vehicle.id"
          :vehicle="vehicle"
        />
      </div>
      <div class="footnote">
        {{ $t('commons.suggested_price') }}
      </div>
    </div>
  </div>
</template>
<script>
import BookingCard from './BookingCard';

export default {
  name: 'BookingCarList',
  components: {
    BookingCard,
  },
  watch: {
    api: {
      handler: 'onApiReady',
      immediate: true,
    },
  },
  data() {
    return {
      filters: [
        'tous',
        'tourisme',
        'utilitaires',
      ],
      activeFilter: 'tous',
    }
  },
  computed: {
    api() {
      return this.$store.state.api;
    },
    canGetPrices() {
      return this.$store.getters['vehicles/canGetPrices'];
    },
    vehicles() {
      return this.$store.state.vehicles.list.allVehicles || [];
    },
    commercialCategory() {
      return this.$store.getters['vehicles/filters/commercialVehicleCategoryId']
    },
    filteredVehicles() {
      if (this.activeFilter === 'tourisme') {
        return this.vehicles.filter(this.notCommercialVehicles)
      }

      if (this.activeFilter === 'utilitaires') {
        return this.vehicles.filter(this.commercialVehicles)
      }

      return this.vehicles
    },
  },
  methods: {
    onApiReady() {
      if (!this.api) {
        return;
      }
      if (!this.vehicles.length) {
        this.$store.dispatch('vehicles/GET_VEHICLE_LIST');
      }
      if (this.canGetPrices) {
        this.$store.dispatch('vehicles/GET_PRICES', this.pickupBusiness);
      }
      this.$store.dispatch('vehicles/filters/GET_CATEGORIES');
    },
    notCommercialVehicles(car) {
      return car.category_id !== this.commercialCategory
    },
    commercialVehicles(car) {
      return car.category_id === this.commercialCategory
    },
  },
};
</script>
<style lang="scss" scoped>

.results-count {
  color: black;
  font-family: $f-graphie-bold;

  @include font-size(16px);
}

.filters {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 65px;
  justify-content: center;
  padding-top: 5px;
  width: 100%;

  @include teq-breakpoint($medium) {
    flex-direction: row;
    padding-top: 0;
  }

  .filters-container {
    align-items: center;
    display: flex;
    height: 65px;
    justify-content: center;
  }
}

label {
  align-items: center;
  color: black;
  cursor: pointer;
  display: flex;
  margin: 0 0 0 15px;
  padding: 0 0 0 20px;
  position: relative;
  text-transform: uppercase;

  @include font-size(16px);

  &:first-child {
    margin: 0;
  }

  &::before,
  &::after {
    content: '';
    left: 0;
    position: absolute;
  }

  &::before {
    border: 1px solid $c-alto;
    height: 15px;
    width: 15px;
  }

  &::after {
    border: 2px solid black;
    border-right: none;
    border-top: none;
    content: '';
    height: 6px;
    left: 3px;
    transform: translateY(-1px) rotate(-45deg) scale(0);
    transition: 100ms ease-out;
    width: 9px;
  }

  input:checked + &::after {
    transform: translateY(-1px) rotate(-45deg);
  }
}

input {
  display: none;
}

.wrapper {
  background: $c-alabaster;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 5;
}

.content {
  max-width: calc(100% - 186px);
  width: 100%;
}

.vehicles {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0;
  width: 100%;

  @include teq-breakpoint($medium) {
    align-items: stretch;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.footnote {
  font-style: italic;
  margin: 3px 0;
  text-align: center;

  @include font-size(14px);
}
</style>
